export class AddMatchedLeadsProductEmailRecipientDto {
    email: string;
    contactId: string;

    constructor(email: string) {
        this.email = email;
    }
}